// Navigation preference only. Never use this marker for identity or permissions.
const RETURNING_USER_KEY = 'legeaaplicata.returning-user';

export function hasPreviousLogin(): boolean {
  try {
    return window.localStorage.getItem(RETURNING_USER_KEY) === '1';
  } catch {
    return false;
  }
}

export function rememberPreviousLogin(): void {
  try {
    window.localStorage.setItem(RETURNING_USER_KEY, '1');
  } catch {
    // Private browsing or a storage restriction must not break authentication.
  }
}
